<template>
    <v-container grid-list-md text-xs-center>
        <v-layout row wrap>
            <v-flex xs12>
                <student-quiz-test-finish-wrapper/>
            </v-flex>
        </v-layout>
    </v-container>
</template>

<script>
    import StudentQuizTestFinishWrapper from "../../components/student/StudentQuizFinishWrapper";
    
    export default {
        components: {
            StudentQuizTestFinishWrapper 
        }
    }
</script>